export default __webpack_public_path__ + "static/media/redis.e35ba92e.png";